module.exports = __webpack_public_path__ + "img/MyProfile.88143b6a.svg";